import React from 'react';
import Search from './components/Search';
import CreateBtn from './components/CreateBtn';
import ChangePositionBtn from './components/ChangePositionBtn';
import { CustomerSelect } from './components/CustomerSelect';
import { RestaurantSelect } from './components/RestaurantSelect';
import CategoryTypeSelect from './components/CategoryTypeSelect';
import ResetBtn from './components/ResetBtn';
import SortBy from './components/SortBy/SortBy';
import CountOfItem from './components/CountOfItem';
import WithURLFilters from './components/WithURLFilters';
import style from './CategoryControlPanel.module.scss';

const CategoryControlPanel: React.FC = () => {
	return (
		<WithURLFilters>
			<div className={style.firstRowWithControls}>
				<Search />
				<CreateBtn />
				<ChangePositionBtn />
			</div>
			<div className={style.secondRowWithControls}>
				<div className={style.selectWrapper}>
					<CustomerSelect />
					<RestaurantSelect />
					<CategoryTypeSelect />
				</div>
				<div className={style.verticalAlignBlock}>
					<ResetBtn />
					<SortBy />
					<CountOfItem />
				</div>
			</div>
		</WithURLFilters>
	);
};

export default CategoryControlPanel;
